var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dialog-form',{attrs:{"value":_vm.value,"title":_vm.$localize('BulkTrashRelations.title', { count: _vm.relationIds.length }),"commit-message":_vm.$localize('BulkTrashRelations.commitMessage'),"allow-continue":false},on:{"input":function($event){return _vm.$emit('input', $event)},"commit":_vm.save}})
}
var staticRenderFns = []

export { render, staticRenderFns }